<template>
  <div id="htmlSnippetContainer">
    <builder-snippet-editor
      header-title="New Email Snippet"
      v-on:load-failure="showLoadError"
      v-on:on-save="handleSave"
    >
    </builder-snippet-editor>
  </div>
</template>

<script>
import SnippetEditor from './SnippetEditor'

export default {
  components: {
    [SnippetEditor.name]: SnippetEditor
  },
  computed: {
  },
  methods: {
    showLoadError (error) {
      this.$router.go(-1)
      this.$flash({
        showClose: true,
        message: 'An error occurred initializing the email editor. Try reloading page. ' + error.message,
        duration: 0,
        type: 'error'
      })
    },
    handleSave (snippetData) {
      this.$router.go(-1)
      this.$flash({
        showclose: true,
        message: `Saved email ${snippetData.type} ${snippetData.name}`,
        type: 'mini',
        duration: 2500
      })
    }
  }
}
</script>
